export const SUPPORT_X = 480;
export const SUPPORT_Y = 70;
export const SUPPORT_WIDTH = 560;
export const SUPPORT_HEIGHT = 40;

export const SUPPORT_BODY_OPTIONS = {
  isStatic: true,
  label: 'support',
  friction: 0.95,
  frictionStatic: 1.2,
  restitution: 0.02,
  plugin: {
    reverseAnimalTower: {
      materialType: 'support',
    },
  },
} as const;
